import { colorVariables } from '@/constants';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export default function CheckCircleIcon({ color = colorVariables.primaryColor, width = 124, height = 124 } : Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_7296_3804)'>
        <circle
          cx='12'
          cy='12'
          r='12'
          fill='#2E7D32'
        />
        <path
          d='M9.32923 15.2288L5.85423 11.7538L4.6709 12.9288L9.32923 17.5871L19.3292 7.58711L18.1542 6.41211L9.32923 15.2288Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_7296_3804'>
          <rect
            width='24'
            height='24'
            rx='12'
            fill={color}
          />
        </clipPath>
      </defs>
    </svg>

  );
}
